import React from 'react';
import './TitleBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMinimize, faWindowMaximize, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/logo.png'; // Assuming your app icon is similar to the logo

const TitleBar = () => {
  const handleMinimize = () => window.electronAPI.minimize();
  const handleMaximize = () => window.electronAPI.maximize();
  const handleClose = () => window.electronAPI.close();

  return (
    <div className="title-bar">
      <div className="title-bar-left">
        <img src={logo} alt="icon" className="title-bar-icon" />
        <span className="title-bar-text">Home | Zakiya</span>
      </div>
      <div className="title-bar-controls">
        <div className="title-bar-button" onClick={handleMinimize}>
          <FontAwesomeIcon icon={faWindowMinimize} />
        </div>
        <div className="title-bar-button" onClick={handleMaximize}>
          <FontAwesomeIcon icon={faWindowMaximize} />
        </div>
        <div className="title-bar-button close" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    </div>
  );
};

export default TitleBar;